import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { storage } from 'src/environments/environment';

export interface DecodedToken {
  name?: string;
  first_name?: string;
  last_name?: string;
  role?: string;
  tenant_id?: string;
  tenant_name?: string;
  tenant_logo?: string;
  user_id?: string;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {
  saveTokens(access: string, refresh?: string) {
    localStorage.setItem(storage.access, access);
    if (refresh) {
      localStorage.setItem(storage.refresh, refresh);
    }
  }

  getAccessToken(): string | null {
    return localStorage.getItem(storage.access);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(storage.refresh);
  }

  decodeAccessToken(): DecodedToken | null {
    const token = this.getAccessToken();
    if (!token) {
      return null;
    }
    const decoded = jwtDecode<DecodedToken>(token);
    if (decoded && decoded.role && typeof decoded.role === 'string') {
      decoded.role = decoded.role.toLowerCase();
    }
    return decoded;
  }

  clearTokenStorage() {
    localStorage.clear();
  }
}
